import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../components/container/MainContainer";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import {
  getAccount,
  getAccountByTerm,
  getExpenditureAccountByTerm,
  getIncomeAccountByTerm,
} from "../../features/accountsSlice";
import PhoneInputField from "../../components/form/PhoneInputField";
import { useDispatch, useSelector } from "react-redux";
import { useNotification } from "../../components/notification/NotificationContainer";
import SelectField from "../../components/form/SelectField";
import { getCurrencies, unsetCurrencies } from "../../features/currenciesSlice";
import {
  addTransaction,
  getMethodTypes,
  unsetMethodTypes,
} from "../../features/transactionsSlice";
import { useCallback, useEffect, useState } from "react";
import SelectField2 from "../../components/form/SelectField2";
import InputField2 from "../../components/form/InputField2";
import AsyncSelectInput2 from "../../components/form/AsyncSelectInput2";
import TextContainer from "../../components/text/TextContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  addPaymenttTransactionSchema,
  addReceiptTransactionSchema,
} from "../../schemas";

const PaymentTransaction = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);
  const methodTypes = useSelector((state) => state.transactions.methodTypes);
  const currencies = useSelector((state) => state.currencies.data);
  const { pathname } = useLocation();
  const addNotification = useNotification();
  const [incomeAcctts, setIncomeAccts] = useState({});
  const [expAccts, setExpAccts] = useState({});

  const {
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: { exchange_rate: 1 },
    resolver: zodResolver(addPaymenttTransactionSchema),
  });

  //
  const watchIncAcc = watch("receiver_id");
  const watchExpAcc = watch("sender_id");
  const watchExchange = watch("exchange_rate");

  //Get Income Account Details
  const getIncAcc = useCallback(async () => {
    try {
      if (!watchIncAcc) {
        setIncomeAccts({});
      } else {
        const res = await dispatch(getAccount(watchIncAcc));
        if (getAccount.fulfilled.match(res)) {
          setIncomeAccts(res.payload);
        }
      }
    } catch (error) {}
  }, [watchIncAcc]);

  //Get Expenditure Account Details
  const getExpAcc = useCallback(async () => {
    try {
      if (!watchExpAcc) {
        setExpAccts({});
      } else {
        const res = await dispatch(getAccount(watchExpAcc));
        if (getAccount.fulfilled.match(res)) {
          setExpAccts(res.payload);
        }
      }
    } catch (error) {}
  }, [watchExpAcc]);

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
      let newData = {
        province_id: user.province_id,
        user_id: user.id,
        method_id: data.method_id,
        currency_id: data.currency_id,
        exchange_rate: data.exchange_rate,
        date: data.date,
        naration: data.naration,
        entries: [
          { account_id: data.sender_id, type: "credit", amount: data.amount },
          {
            account_id: data.receiver_id,
            type: "debit",
            amount: data.amount,
          },
        ],
        transactionDetails: [],
      };

      const res = await dispatch(addTransaction(newData));
      if (addTransaction.fulfilled.match(res)) {
        addNotification(res.payload.message, "success");
        navigate("/accounts/transaction");
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  //Chec startk path
  useEffect(() => {
    dispatch(getMethodTypes());
    dispatch(getCurrencies());

    reset({ exchange_rate: 1 });

    return () => {
      dispatch(unsetMethodTypes());
      dispatch(unsetCurrencies());
    };
  }, []);

  //Income
  useEffect(() => {
    getIncAcc();
  }, [watchIncAcc]);

  //Expenditure
  useEffect(() => {
    getExpAcc();
  }, [watchExpAcc]);

  useEffect(() => {
    if (
      expAccts.id &&
      incomeAcctts.id &&
      expAccts.currency === incomeAcctts.currency
    ) {
      // reset({ exchange_rate: 1 });
      setValue("exchange_rate", 1);
    } else {
    }
  }, [expAccts, incomeAcctts, setValue, watchExchange]);

  return (
    <MainContainer className="bg-content pb-10">
      <div className="text-text-1">
        <div className="sm:px-10 lg:px-20 xl:px-40 2xl:px-60">
          <h3 className="text-text-1/80 mb-5">Payment</h3>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="sm:px-10 lg:px-20 xl:px-40 2xl:px-60">
            <div className="flex items-center justify-between gap-2 md:gap-20 flex-col md:flex-row">
              <SelectField2
                register={register}
                name="method_id"
                labelWidth=" w-40"
                label="Type"
                errors={errors.method_id}
                data={[{ id: null, name: "-- Select Type" }, ...methodTypes]}
              />
              <SelectField2
                register={register}
                name="currency_id"
                label="Currency"
                labelWidth=" w-40"
                errors={errors.currency_id}
                data={[{ id: null, name: "-- Select Currency" }, ...currencies]}
              />
            </div>
            <div className="flex items-center justify-between gap-2 md:gap-20 flex-col md:flex-row">
              <InputField2
                name="date"
                label="Date"
                labelWidth=" w-40"
                errors={errors.date}
                type="date"
                defaultValue={new Date().toISOString().split("T")[0]}
                register={register}
              />
              <InputField2
                register={register}
                name="exchange_rate"
                label="Exchange Rate"
                labelWidth=" w-40"
                type="number"
                errors={errors.exchange_rate}
              />
            </div>
            <div className="flex items-center justify-between gap-2 md:gap-20 flex-col md:flex-row">
              {expAccts.id && (
                <div className="border border-bkg2 rounded-md bg-bkg2 px-3 py-2 w-auto  flex flex-col sm:flex-row mb-2 gap-2 sm:gap-10">
                  <>
                    <div>
                      <TextContainer
                        label="Currency"
                        content={expAccts.currency}
                      />
                    </div>
                    <div>
                      <TextContainer
                        label="Balance"
                        content={`${expAccts.symbol} ${expAccts.balance}`}
                      />
                    </div>
                  </>
                </div>
              )}
            </div>
            <div className="flex items-center justify-between gap-10 sm:gap-40">
              <AsyncSelectInput2
                name="sender_id"
                register={register}
                setValue={setValue}
                label="From Account"
                labelWidth=" w-52"
                errors={errors.sender_id}
                fetchOptions={getAccountByTerm}
              />
            </div>
            <div className="flex items-center justify-between gap-2 md:gap-20 flex-col md:flex-row">
              {incomeAcctts.id && (
                <div className="border border-bkg2 rounded-md bg-bkg2 px-3 py-2 w-auto  flex flex-col sm:flex-row mb-2 gap-2 sm:gap-10">
                  <>
                    <div>
                      <TextContainer
                        label="Currency"
                        content={incomeAcctts.currency}
                      />
                    </div>
                    <div>
                      <TextContainer
                        label="Balance"
                        content={`${incomeAcctts.symbol} ${incomeAcctts.balance}`}
                      />
                    </div>
                  </>
                </div>
              )}
            </div>
            <div className="flex items-center justify-between gap-10 sm:gap-40">
              <AsyncSelectInput2
                name="receiver_id"
                label="To Account"
                labelWidth=" w-52"
                register={register}
                setValue={setValue}
                errors={errors.receiver_id}
                fetchOptions={getAccountByTerm}
              />
            </div>
            <div className="flex items-center justify-between gap-10 sm:gap-40">
              <InputField2
                name="amount"
                placeholder="Amount"
                label="Amount"
                labelWidth=" w-52"
                errors={errors.amount}
                register={register}
                type="number"
              />
            </div>
            <div className="flex items-center justify-between gap-10 sm:gap-40">
              <InputField2
                name="naration"
                label="Naration"
                autoComplete="off"
                labelWidth=" w-52"
                errors={errors.naration}
                type="text"
                register={register}
              />
            </div>

            {/* <div className="">
              <p className="">Transaction</p>
              <div className="flex justify-evenly items-end gap-10 sm:gap-20"></div>
              <div className="mt-3 h-72 border border-bkg2 pt-3 px-2"></div>
            </div> */}

            <ResourseButtons link text="Back" to="/accounts/transaction" />
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default PaymentTransaction;
